let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("GNuQo")).then(() => parcelRequire('eMR6r'));